// extracted by css-extract-rspack-plugin
export default {"banner":"banner-t2VcN8"};